import { useState, useEffect } from "react";
import { CalendarDialog } from "@/components/CalendarDialog";
import { motion, AnimatePresence } from "framer-motion";

export function MobileStickyCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero section (approx 500px)
      setIsVisible(window.scrollY > 500);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="mobile-sticky-cta safe-area-bottom"
        >
          <CalendarDialog
            buttonVariant="hero"
            buttonSize="default"
            buttonClassName="w-full h-11 text-sm font-semibold rounded-lg justify-center"
            showArrow={false}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}